module.exports = __webpack_public_path__ + "static/2front-mobile-1-782134969a0d70693851db9f2758791a.png";